export function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand ${compact ? "brand--compact" : ""}`}>
      <img
        src="/brand/quasaryx-wordmark.svg"
        alt="Quasaryx"
      />
      {!compact && <span>CENTRO DE COMANDO SATELITAL</span>}
    </div>
  );
}
